import { Color } from '@previo/codebooks'

export type PTimelineEntry = {
  id: number
  type?: PTimelineEntryType
  icon?: string
  avatar?: string
  text: string
  tagText: string
  tagColor: Color.POSITIVE | Color.WARNING | Color.NEGATIVE | Color.INFO | Color.GREY_600
}

export enum PTimelineEntryType {
  PIN = 'pin',
  ICON = 'icon',
  AVATAR = 'avatar',
}
